import {inject, Injectable} from '@angular/core';
import {ListDataStore} from '../stores/list-data.store';
import {PaginatedListData} from '../models/paginated-list-data.model';
import {EntityQueryService} from '../modules/akita-mimic/services/entity-query.service';
import {ListDataState} from '../modules/akita-mimic/models/store-states/list-data-state.model';
import {SortOrder} from '../modules/akita-mimic/enums/sort-order.enum';

@Injectable({ providedIn: 'root' })
export class ListDataQuery extends EntityQueryService<ListDataState, PaginatedListData> {

    public constructor() {
        const store = inject(ListDataStore);

        super(store, {
            sortBy: 'id',
            sortByOrder: SortOrder.ASC
        });
    }

    public getPaginatedListData(name: string): PaginatedListData | undefined {
        return this.getEntity(name);
    }
}
